<template>
  <div class="ui-list">
    <ListHeader
      v-for="column in columns"
      :key="column.name"
      :name="column.caption"
      :header-class="column.headerClass"
    />
    <div
      v-if="!unremovable"
      class="ui-list__header"
    />
    <ListRow
      v-for="(item, index) in items"
      :key="getKey?.(item) || index"
      :columns
      :item
      :unremovable
      :hovered="hoveredIndex === index"
      @remove="handleRemove(index, item)"
      @mouseenter="handleMouseEnter(index)"
      @mouseleave="handleMouseLeave"
    >
      <template
        v-for="column in columns"
        :key="column.name"
        #[column.name]="slotProps"
      >
        <slot
          :name="column.name"
          v-bind="slotProps"
        />
      </template>
    </ListRow>
  </div>
</template>

<script setup lang="ts">
import { ListColumn, ListItem } from './utils/types'

import ListHeader from './ListHeader.vue'
import ListRow from './ListRow.vue'
import { ref } from 'vue'

type Props = {
  columns: ListColumn[]
  items: ListItem[]
  unremovable?: boolean
  getKey?: (item: ListItem) => string | number
}

type Emits = {
  remove: [index: number, item: ListItem]
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const hoveredIndex = ref<number>()

const handleRemove = (index: number, item: ListItem) => emit('remove', index, item)

const handleMouseEnter = (index: number) => hoveredIndex.value = index
const handleMouseLeave = () => hoveredIndex.value = undefined
</script>

<style>
.ui-list {
  @apply grid;
}
</style>
